import { useState } from 'react';
import { useRecordContext, useResourceContext, useTranslate } from 'react-admin';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { AuditTimelineCompact } from './AuditTimeline';

interface AuditButtonProps {
  resourceType?: string;
  resourceId?: number | string;
}

export const AuditButton = ({ resourceType: propResourceType, resourceId: propResourceId }: AuditButtonProps) => {
  const translate = useTranslate();
  const record = useRecordContext();
  const contextResourceType = useResourceContext();
  const [open, setOpen] = useState(false);

  const resourceType = propResourceType || contextResourceType || record?.resourceType || 'resource';
  const resourceId = propResourceId || record?.id;

  if (!resourceId) return null;

  return (
    <>
      <Button
        startIcon={<HistoryIcon />}
        onClick={() => setOpen(true)}
        size="small"
      >
        {translate('common.audit.button')}
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {translate(`resources.${resourceType}.audit.title`, {
            _: translate('common.audit.title')
          })}
        </DialogTitle>
        <DialogContent dividers>
          <AuditTimelineCompact
            resourceType={resourceType}
            resourceId={Number(resourceId)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>
            {translate(`resources.${resourceType}.audit.close`, {
              _: translate('common.audit.close')
            })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
